module.exports = __webpack_public_path__ + "img/1509378272.0c7b8459.jpg";